<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section', block.bgcolour]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container">
        <div class="columns is-variable is-6">
            <div class="column is-4">
                <h2 :class="['title', block.title_colour]">{{block.title}}</h2>
            </div>
            <div class="column is-8">
                <ul class="bulletpoints" v-if="block.bulletpoints && block.bulletpoints.length > 0">
                    <ExpandableLi :bullet="bullet" :colour="block.title_colour.replace(/colour\-/gi, 'bg-')" :key="i" v-for="bullet, i in block.bulletpoints" />
                </ul>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
import ExpandableLi from './elements/ExpandableLi';
export default {
    name        :   'BulletpointsBlock',
    mixins      :   [ BlockCommons ],
    components  :   { ExpandableLi }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/BulletpointsBlock.vue